import { fn } from 'next-common-lib';

export const popupWriteForm = options => {
  const initModule = options.initModule; // 최초진입 모듈
  const userId = options.userId; // 사용자id
  const cUserId = options.cUserId; // 사용자id
  const uid = options.uid; // uid
  const groupId = options.groupId; // groupid
  const saveCallback = options.saveCallback; // 저장 후 callback
  const errorCallback = options.errorCallback; // 에러 발생 콜백
  const cancelCallback = options.cancelCallback; // 취소 콜백
  const deleteCallback = options.deleteCallback; // 삭제 후 callback
  const draftCallback = options.draftCallback; // 임시저장 후 callback
  const onloadCallback = options.onloadCallback; // 임시저장 후 callback

  const popWidth = options.popupWidth || 1088;
  const popHeight = options.popupHeight || 665;
  let leftPosition =
    options.leftPosition ||
    (window.screen.width - popWidth > 0
      ? (window.screen.width - popWidth) / 2
      : (window.screen.availWidth - popWidth) / 2);
  let topPosition =
    options.topPosition ||
    (window.screen.height - popHeight > 0
      ? (window.screen.height - popHeight) / 2
      : (window.screen.availHeight - popHeight) / 2);

  let url = 'formapp/';
  url += `?initModule=${initModule}`;

  if (userId) {
    url += `&userId=${userId}`;
  }
  if (cUserId) {
    url += `&cUserId=${cUserId}`;
  }
  if (uid) {
    url += `&uid=${uid}`;
  }
  if (groupId) {
    url += `&groupId=${groupId}`;
  }

  let domainInfo = '';
  if (options.compDomain !== undefined && options.compDomain !== null && options.compDomain.length > 0) {
    domainInfo = options.compDomain;
  } else {
    domainInfo = options.domainSet;
  }
  const domainUrl = fn.changeDomainURL(domainInfo);
  options.domainUrl = domainUrl;

  let defaultHeight = '665';
  if (window.screen !== undefined) {
    if (window.screen.height >= 1080) {
      defaultHeight = '900';
    } else if (window.screen.height < 1080 && window.screen.height >= 900) {
      defaultHeight = '780';
    }
  }

  options.popupHeight = defaultHeight;

  const windowName = options.popupName || `newWrite${Math.random().toString(36).substr(2, 11)}`;
  leftPosition -= 10;
  topPosition -= 20;

  const winStyle = `width=${popWidth}, height=${popHeight}, left=${leftPosition}, top=${topPosition}, toolbar=no, resizable=yes, scrollbars=yes`;

  window.domainModel = options.domainModel;
  window.viewModel = options.viewModel;

  window.saveCallbackToParent = data => {
    if (saveCallback && typeof saveCallback === 'function') {
      setTimeout(function () {
        saveCallback(data);
      }, 0);
    }
  };
  window.errorCallbackToParent = data => {
    if (errorCallback && typeof errorCallback === 'function') {
      setTimeout(function () {
        errorCallback(data);
      }, 0);
    }
  };
  window.cancelCallbackToParent = () => {
    if (cancelCallback && typeof cancelCallback === 'function') {
      setTimeout(function () {
        cancelCallback();
      }, 0);
    }
  };
  window.deleteCallbackToParent = () => {
    if (deleteCallback && typeof deleteCallback === 'function') {
      setTimeout(function () {
        deleteCallback();
      }, 0);
    }
  };
  window.draftCallbackToParent = () => {
    if (draftCallback && typeof draftCallback === 'function') {
      setTimeout(function () {
        draftCallback();
      }, 0);
    }
  };
  window.onloadCallbackToParent = () => {
    if (onloadCallback && typeof onloadCallback === 'function') {
      setTimeout(function () {
        onloadCallback();
      }, 0);
    }
  };

  const popWin = window.open(options.domainUrl + url, windowName, winStyle);
  if (options.popupTitle) {
    popWin.document.title = options.popupTitle;
  }
  // popWin.focus();
  return popWin;
};

export default {
  popupWriteForm,
};
